import "./Description.css";

export const Description = () => (
  <div className="description-box">
    <p className="description-title">We are WHY WE DESIGN</p>
    <p className="description-title">Strategy, Creative and</p>
    <p className="description-title">Sustainable Design Studio.</p>
    <p className="description-title">Powered by Women!</p>
    <p className="description-title">
      <a className="no-link" href="https://www.instagram.com/whywedesign.co/" target="_blank">Instagram</a>
      <a className="no-link pl15" href="https://www.linkedin.com/company/106818429/admin/dashboard/" target="_blank">Linkedin</a>
    </p>
  </div>
);
